// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2xEdW","productName":"Table_productName__3ZCGp"};